const getNameOrDefName = (name, defName) => {
  return (name && name.length) ? name : defName;
};
export default getNameOrDefName;